module.exports = __webpack_public_path__ + "omniv2/img/icon-lock2.e970bb51.svg";